const AwardsRecognitions = () => {
    const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;
    return (
        <section className="py-3">
            <div className="container text-center pt-5">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <h3 className="font-bold text-black text-4xl">
                            Awards and Recognitions
                        </h3>
                    </div>
                </div>
                <div className="row mb-4 text-left">
                    <div className="col-12 col-md-6 col-lg-3 pb-3">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Lumakras.png`}
                            alt="Lumakras"
                            className="my-5 mx-auto d-block"
                        />
                        <p>
                            <span className='font-bold text-black'>Lumakras&reg;</span> (sotorasib) Amgen's treatment for extensive-stage small cell lung cancer (ES-SCLC) was named one of ‘TIME's Best Inventions of 2024.’                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Evenity.png`}
                            alt="Evenity"
                            className="my-5 mx-auto d-block"
                        /><p>
                            <span className='font-bold text-black'>Evenity&reg;</span>, Amgen’s breakthrough osteoporosis treatment named ‘Drug Name of the Year’ by Fierce Biotech, 2023.                        </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/JustCrackAnEgg.png`}
                            alt="JustCrackAnEgg"
                            className="my-5 mx-auto d-block"
                        /><p>
                            <span className='font-bold text-black'>Just Crack an Egg&reg;</span> brand was named a Top 10 Rising Star by IRI’s ‘New Product Pacesetters Report,’ 2022.                  </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/XBOX.png`}
                            alt="XBOX"
                            className="my-5 mx-auto d-block"
                        /><p>
                            Creativity Magazine’s ‘Excellence in Naming Innovation Award’ given to <span className='font-bold text-black'>Xbox&reg;</span>, 2002.           </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Auvelity.png`}
                            alt="Auvelity"
                            className="my-5 mx-auto d-block"
                        /><p>
                            <span className='font-bold text-black'>Auvelity&reg;</span> (dextromethorphan HBr-bupropion HCl), developed by Axsome Therapeutic, declared ‘HHI/iQvia Drug Name of the Year Award’, 2023.         </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Dreamcast.png`}
                            alt="Dreamcast"
                            className="my-5 mx-auto d-block"
                        /><p>
                            The BrandWeek Council’s ‘Brand Name of the Year Award,’ <span className='font-bold text-black'>Dreamcast&reg;</span> by Sega, 1999.       </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/acela.png`}
                            alt="acela"
                            className="my-5 mx-auto d-block"
                        /><p>
                            The BrandWeek Council’s ‘Brand Name of the Year Award’ was bestowed on <span className='font-bold text-black'>Amtrak’s Acela&reg;</span> in 2001.    </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/cadillac.png`}
                            alt="cadillac"
                            className="my-5 mx-auto d-block"
                        /><p>
                            Cadillac’s <span className='font-bold text-black'>Escalade&reg;</span> awarded ‘Car Brand of the Year Award’ by Automobile Magazine, 2001.   </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Samsung.png`}
                            alt="Samsung"
                            className="my-5 mx-auto d-block"
                        /><p>
                            In 2012, the Samsung <span className='font-bold text-black'>Galaxy&reg;</span> was awarded ‘Phone of the Year, Best Design and Most Innovative Branding Awards’ at the Mobile Choice Consumer Awards. </p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Pontiac.png`}
                            alt="Pontiac"
                            className="my-5 mx-auto d-block"
                        /><p>
                            The Pontiac <span className='font-bold text-black'>Sunfire&reg;</span> was awarded the ‘Car Name of the Year’ by Automotive Digest, 1996.</p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Infineon.png`}
                            alt="Infineon"
                            className="my-5 mx-auto d-block"
                        /><p>
                            <span className='font-bold text-black'>Infineon Technologies&reg;</span> receives the ‘Corporate Identity Brand Innovation Award’ bestowed by Inside PR Magazine, 2000.</p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Abbott.png`}
                            alt="Abbott"
                            className="my-5 mx-auto d-block"
                        /><p>
                            Abbott’s <span className='font-bold text-black'>XIENCE&reg;</span> stent wins Medical Product Manufacturing News (MPMN) ‘Medical Device Branding Innovation Award,’ 2009.</p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Remicade.png`}
                            alt="Remicade"
                            className="my-5 mx-auto d-block"
                        /><p>
                            <span className='font-bold text-black'>Remicade&reg;</span> (infliximab, from Centocor (now J&J), wins the Brand Week’s ‘Healthcare Brand Name of the Year Award’ in 1999.</p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3 ">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Honda.png`}
                            alt="Honda"
                            className="my-5 mx-auto d-block"
                        /><p>
                            The Honda <span className='font-bold text-black'>Element&reg;</span> awarded ‘Car Name of the Year’ by Automotive Digest, 2003.</p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Abbott.png`}
                            alt="Abbott"
                            className="my-5 mx-auto d-block"
                        /><p>
                            Abbott’s <span className='font-bold text-black'>FreeStyle&reg;</span> Blood Glucose Monitoring System awarded “Brand Innovation of 1999 ” by Medical Device & Diagnostic Industry (MD&DI) Magazine.</p>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 pb-3">
                        <img
                            src={`${awsImageBaseUrl}images/AwardsRecognitions/Humira.png`}
                            alt="Abbott"
                            className="my-5 mx-auto d-block"
                        /><p>
                            Abbott’s <span className='font-bold text-black'>Humira</span> Awarded best integrated brand launch from PharmaVOICE, 2004</p>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default AwardsRecognitions;
